import React, { Component } from 'react';
import ModifyLog from './Components/ModifyLog';
import Export from './Components/Export';
import MessageBoard from './Components/MessageBoard';
import SelectCompareVersion from './Components/SelectCompareVersion';

class index extends Component {
    state = {
        messageBoardVisible: false,
    }

    selectCompareVersion = () => {
        this.selectVersionRef.show();
    }

    showModifyLog = () => {
        this.modifyLogRef.show();
    }

    showExport = () => {
        this.exportRef.show();
    }

    toggleMessageBoardDisplay = () => {
        this.setState(prevState => ({ messageBoardVisible: !prevState.messageBoardVisible }));
    }

    render() {
        const { messageBoardVisible } = this.state;
        return (
            <aside className="quotation_sidebar">
                <ul className="quotation_sidebar_list">
                    <li className="quotation_sidebar_item">切换成英文</li>
                    <li className="quotation_sidebar_item" onClick={this.selectCompareVersion}>版本对比</li>
                    <li className="quotation_sidebar_item">单中心费用</li>
                    <li className="quotation_sidebar_item" onClick={this.showExport}>导出报价单</li>
                    <li className="quotation_sidebar_item" onClick={this.showModifyLog}>修改日志</li>
                    <li className="quotation_sidebar_item" onClick={this.toggleMessageBoardDisplay}>留言板</li>
                </ul>
                <SelectCompareVersion ref={el => this.selectVersionRef = el} />
                <ModifyLog ref={el => this.modifyLogRef = el} />
                <Export ref={el => this.exportRef = el} />
                { messageBoardVisible && <MessageBoard toggleMessageBoardDisplay={this.toggleMessageBoardDisplay} /> }
            </aside>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/quotation/Sidebar/index.js